import type {
  AdFieldBathsEnum,
  AdFieldBedsEnum,
  AdFieldFloorEnum,
  AdFieldFurnitureEnum,
  AdFieldOccupancyEnum,
  AdFieldRenovationEnum,
  AdsFilteringType,
  CompletionStatusEnum,
  TransactionTypeEnum,
} from '@/types';

import type { FilterState } from './filterTypes';

export const createInitialFilterState = (): FilterState => ({
  locationId: [],
  propertyKind: [],
  transactionType: [],
  rentFrequency: undefined,
  completionStatus: [],
  beds: [],
  baths: [],
  furniture: [],
  renovation: [],
  floor: [],
  occupancy: [],
  postHandover: undefined,
  handover: {
    quarter: undefined,
    year: undefined,
  },
  multiHandover: [],
  price: {
    priceMin: undefined,
    priceMax: undefined,
  },
  size: {
    areaMin: undefined,
    areaMax: undefined,
  },
  downPayment: undefined,
  keywords: undefined,
  creator: {
    id: undefined,
    name: undefined,
    kind: undefined,
  },
  isMyAgency: undefined,
  myFriends: undefined,
});

export const createFilterStateFromFilteringObj = (filteringObj: AdsFilteringType): FilterState => {
  const newFloor = filteringObj.floor as AdFieldFloorEnum[];
  const floor = newFloor?.map((item) => item as AdFieldFloorEnum);
  const multiHandover = filteringObj.multiHandover
    ? filteringObj.multiHandover
    : filteringObj.handover?.year
      ? [filteringObj.handover.year]
      : [];

  return {
    locationId: (filteringObj.locationId as string[]) || [],
    transactionType: (filteringObj.transactionType as TransactionTypeEnum[]) || [],
    rentFrequency: filteringObj.rentFrequency,
    completionStatus: (filteringObj.completionStatus as CompletionStatusEnum[]) || [],
    propertyKind: filteringObj.propertyKind || [],
    beds: (filteringObj.beds as AdFieldBedsEnum[]) || [],
    downPayment: filteringObj.downPayment,
    baths: (filteringObj.baths as AdFieldBathsEnum[]) || [],
    furniture: (filteringObj.furniture as AdFieldFurnitureEnum[]) || [],
    renovation: (filteringObj.renovation as AdFieldRenovationEnum[]) || [],
    postHandover: filteringObj.postHandover ?? undefined,
    floor: floor || [],
    occupancy: (filteringObj.occupancy as AdFieldOccupancyEnum[]) || [],
    keywords: filteringObj.keywords,
    isMyAgency: filteringObj.isMyAgency || false,
    myFriends: filteringObj.myFriends || false,
    multiHandover,
    size: {
      areaMin: filteringObj.areaMin as unknown as FilterState['size']['areaMin'],
      areaMax: filteringObj.areaMax as unknown as FilterState['size']['areaMax'],
    },
    price: {
      priceMin: filteringObj.priceMin as FilterState['price']['priceMin'],
      priceMax: filteringObj.priceMax as FilterState['price']['priceMax'],
    },
    handover: {
      quarter: filteringObj.handover?.quarter,
      year: filteringObj.handover?.year,
    },
    creator: {
      id: filteringObj.creator?.id,
      name: filteringObj.creator?.name,
      kind: filteringObj.creator?.kind,
    },
  };
};

export const countNonEmptyFilterFields = (filterState: FilterState): number => {
  let count = 0;

  Object.entries(filterState).forEach(([key, value]) => {
    if (key === 'isMyAgency') {
      return;
    }

    if (key === 'myFriends') {
      if (value === true) count++;
      return;
    }

    if (Array.isArray(value)) {
      if (value.length > 0) count++;
    } else if (typeof value === 'object' && value !== null) {
      if (
        Object.values(value).some(
          (subValue) => subValue !== undefined && subValue !== null && subValue !== ''
        )
      ) {
        count++;
      }
    } else if (value !== undefined && value !== null && value !== '') {
      count++;
    }
  });

  return count;
};
